import { Box, Button, Container, Typography, SxProps, Theme } from "@mui/material";
import recruitHeroBackground from "../../../resources/images/recruit_hero_background.jpg";

export const HeroSection = () => {
  const scrollToRequirements = () => {
    const element = document.getElementById("requirements-section");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <Box sx={heroSx}>
      <Box sx={overlaySx} />
      <Container maxWidth="lg" sx={{ position: "relative", zIndex: 2 }}>
        <Box sx={contentSx}>
          <Typography variant="h1" sx={headingSx}>
            安心と信頼 × 高度な技術力
            <br />
            高品質な開発を基準に
          </Typography>
          <Typography sx={subCopySx}>
            2022年創業。自動車・食品・航空など多様な業界の大手企業の開発を支えてきたテクノスタンダード。安心と信頼をベースに、高度な技術力で高品質な開発を届ける——そのスタンダードを一緒につくるエンジニアを募集しています。
          </Typography>
          <Box sx={badgeContainerSx}>
            <Box sx={badgeSx}>インターン</Box>
            <Box sx={badgeSx}>新卒・第二新卒</Box>
            <Box sx={badgeSx}>中途</Box>
          </Box>
          <Button sx={ctaButtonSx} onClick={scrollToRequirements}>
            エントリーする
          </Button>
          <Typography sx={reassuranceTextSx}>面接1回・フルリモート可・学歴不問</Typography>
        </Box>
      </Container>
    </Box>
  );
};

const heroSx: SxProps<Theme> = {
  position: "relative",
  backgroundImage: `url(${recruitHeroBackground})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  minHeight: { md: "100vh", xs: "auto" },
  display: "flex",
  alignItems: "center",
  width: "100%",
  boxSizing: "border-box",
  padding: { md: 0, xs: "80px 0 60px" },
};

const overlaySx: SxProps<Theme> = {
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: "rgba(26, 26, 46, 0.75)",
  zIndex: 1,
};

const contentSx: SxProps<Theme> = {
  maxWidth: "800px",
  color: "#FFFFFF",
  textAlign: "center",
  margin: "0 auto",
  padding: { md: 0, xs: "0 16px" },
  boxSizing: "border-box",
};

const headingSx: SxProps<Theme> = {
  fontSize: { md: "56px", xs: "28px" },
  fontWeight: 700,
  lineHeight: 1.3,
  marginBottom: { md: "32px", xs: "24px" },
  wordBreak: { md: "keep-all", xs: "normal" },
};

const subCopySx: SxProps<Theme> = {
  fontSize: { md: "18px", xs: "15px" },
  lineHeight: 1.9,
  marginBottom: { md: "32px", xs: "24px" },
  color: "rgba(255, 255, 255, 0.85)",
};

const badgeContainerSx: SxProps<Theme> = {
  display: "flex",
  gap: "12px",
  marginBottom: { md: "40px", xs: "32px" },
  flexWrap: "wrap",
  justifyContent: "center",
};

const badgeSx: SxProps<Theme> = {
  background: "rgba(255, 255, 255, 0.2)",
  border: "1px solid rgba(255, 255, 255, 0.5)",
  borderRadius: "20px",
  padding: "8px 20px",
  fontSize: { md: "14px", xs: "12px" },
  fontWeight: 600,
};

const ctaButtonSx: SxProps<Theme> = {
  background: "linear-gradient(135deg, #22A1B9, #00BFA5)",
  color: "#FFFFFF",
  fontWeight: 700,
  padding: { md: "18px 56px", xs: "16px 48px" },
  fontSize: { md: "18px", xs: "16px" },
  borderRadius: "8px",
  textTransform: "none",
  transition: "all 0.3s",
  boxShadow: "0 4px 15px rgba(34, 161, 185, 0.4)",
  marginBottom: { md: "24px", xs: "20px" },
  "&:hover": {
    background: "linear-gradient(135deg, #1d8fa3, #00a890)",
    transform: "translateY(-2px)",
    boxShadow: "0 8px 25px rgba(34, 161, 185, 0.5)",
  },
};

const reassuranceTextSx: SxProps<Theme> = {
  fontSize: { md: "14px", xs: "12px" },
  color: "rgba(255, 255, 255, 0.7)",
};
